<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {
      token: '',
      oldToken: '',
      jwtToken: '',
      jumpUrl: '',
      organId: '',
    };
  },
  created() {
    this.oldToken = this.$route.query.token; // 短token
    this.token = this.$route.query.jwtToken; // 长token
    this.jumpUrl = this.$route.query.jumpUrl;
    this.organId = this.$route.query.organId;
    // 区分是不是单点登录进入的
    sessionStorage.setItem('browser', 'browser');
    sessionStorage.setItem('organId', this.organId);
    this.login();
  },
  methods: {
    login() {
      sessionStorage.setItem('token', this.token);
      this.$http.post(`${this.$API.getUserInfo}?token=${this.oldToken}`).then(async ({ success, data }) => {
        if (success) {
          this.$store.dispatch('app/updateLoginInfo', {
            userInfo: data,
          });
          sessionStorage.setItem('userInfo', JSON.stringify(data));
          this.$router.push({ path: this.jumpUrl });
        } else {
          this.$router.push({ path: '/login' });
        }
      });
    },
    // 获取登录菜单权限
    getMenus() {
      const params = {
        platform: 'SERVICE',
      };
      return new Promise((resolve, reject) => {
        this.$http
          .get(this.$API.permission_staffs_menuTree, { params })
          .then((res) => {
            if (res.success && res.data && res.data.length) {
              resolve(res.data);
            } else {
              reject('');
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
</script>

<style lang="scss"></style>
